module.exports = __webpack_public_path__ + "static/media/profit.69827b80.png";